import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import './LostOrStolen.scss';
import { getImageProps } from 'app/utilities/ImageProps';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import successIcon from './images/success-icon-check.svg';
import errorIcon from './images/error-icon-check.svg';
import useWindowSize from 'app/utilities/hooks/useWindowSize';
import ProviderManager from 'app/provider/providerManager';
import {
  dwhMarketingPageEntry,
  dwhSerialNumberInput,
  dwhCheckButtonClick,
  dwhCheckSuccess,
  dwhCheckFailure
} from './dwhReports';

const LostOrStolen = ({ context, contentData }) => {
  const title = contentData.title?.value || '';
  const [imei, setImei] = useState('');
  const [imeiError, setImeiError] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [checkResult, setCheckResult] = useState(null);
  const [hasTrackedInput, setHasTrackedInput] = useState(false);

  const { width } = useWindowSize();
  const isMobile = width < 768;

  // Track page entry when component mounts
  useEffect(() => {
    dwhMarketingPageEntry('');
  }, []);
  const validateIMEIWithLuhn = (imeiNumber) => {
    const digits = imeiNumber.replace(/\D/g, '');

    if (digits.length !== 15) {
      return false;
    }

    let sum = 0;

    for (let i = 0; i < digits.length; i++) {
      let digit = parseInt(digits[i]);
      if (i % 2 === 1) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
    }
    return sum % 10 === 0;
  };

  const firstImageMobile = contentData.firstImageMobile?.expandedValue?.url ? getImageProps(contentData.firstImageMobile, context) : null;
  const firstImageDesktop = contentData.firstImageDesktop?.expandedValue?.url ? getImageProps(contentData.firstImageDesktop, context) : null;
  const secondImageMobile = contentData.secondImageMobile?.expandedValue?.url ? getImageProps(contentData.secondImageMobile, context) : null;
  const secondImageDesktop = contentData.secondImageDesktop?.expandedValue?.url ? getImageProps(contentData.secondImageDesktop, context) : null;
  const thirdImageMobile = contentData.thirdImageMobile?.expandedValue?.url ? getImageProps(contentData.thirdImageMobile, context) : null;
  const thirdImageDesktop = contentData.thirdImageDesktop?.expandedValue?.url ? getImageProps(contentData.thirdImageDesktop, context) : null;

  const firstImage = isMobile ? firstImageMobile : firstImageDesktop;
  const secondImage = isMobile ? secondImageMobile : secondImageDesktop;
  const thirdImage = isMobile ? thirdImageMobile : thirdImageDesktop;

  console.log("firstimage value:", firstImageMobile);

  const handleImeiChange = (e) => {
    const value = e.target.value;
    const digitsOnly = value.replace(/\D/g, '').slice(0, 15);
    
    // Track serial number input only on first character entry
    if (digitsOnly.length === 1 && !hasTrackedInput) {
      dwhSerialNumberInput();
      setHasTrackedInput(true);
    }
    
    setImei(digitsOnly);
    if (imeiError) {
      setImeiError('');
    }
    if (checkResult) {
      setCheckResult(null);
    }
    
    // Reset tracking flag if input is cleared
    if (digitsOnly.length === 0) {
      setHasTrackedInput(false);
    }
  };

  const displayResult = (isSuccess) => {
    if (isSuccess) {
      setCheckResult('success');
    } else {
      setCheckResult('failure');
    }
  };

  const handleCheckImei = async () => {
    setCheckResult(null);

    if (!imei || imei.trim() === '') {
      setImeiError('הזינו את המספר הסידורי');
      return;
    }

    if (imei.length !== 15) {
      setImeiError('מספר סידורי צריך להכיל 15 ספרות,אפשר לנסות שוב');
      return;
    }

    if (!/^\d{15}$/.test(imei)) {
      setImeiError('מספר סידורי לא תקין');
      return;
    }

    if (!validateIMEIWithLuhn(imei)) {
      setImeiError('משהו קרה, נסו שוב מאוחר יותר');
      return;
    }

    setImeiError('');
    console.log('Checking IMEI:', imei);

    // Track check button click
    dwhCheckButtonClick();

    try {
      const result = await ProviderManager.getProviderData('checkImeiStatus', [imei]);

      if (result && result.Header && result.Header.ReturnCode === 0) {
        const imeiStatus = result.Body?.imeiStatus;

        if (imeiStatus === 'A' || imeiStatus === 'C') {
          displayResult(true);
          dwhCheckSuccess();
        } else if (imeiStatus === 'B') {
          displayResult(false);
          dwhCheckFailure();
        } else {
          setCheckResult(null);
          setImeiError('שגיאה בבדיקת המספר הסידורי');
          dwhCheckFailure();
        }
      } else {
        setCheckResult(null);
        setImeiError('שגיאה בבדיקת המספר הסידורי');
        dwhCheckFailure();
      }

    } catch (error) {
      console.error('API call failed:', error);
      setCheckResult(null);
      setImeiError('שגיאה בבדיקת המספר הסידורי');
      dwhCheckFailure();
    }
  };

  const handleShowPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className='LostOrStolenBlock'>
      {firstImage && (
        <Image {...firstImage} className='LostOrStolenBlock__first-image' />
      )}
      <div className='locked-phone-check'>
        <div className='locked-phone-check-card'>
          <div className='txt-box'>
          <span className='locked-phone-check-card-title'>האם המכשיר שלי חסום?</span>
          <span className='locked-phone-check-card-description'>יש להכניס את המספר הסידורי <br/> של המכשיר אותו תרצו לבדוק</span>
          </div>
          <div className='check-field'>
            <TextInput
              className='check-field-input'
              type="text"
              name="imei"
              placeholder="מספר סידורי"
              value={imei}
              onChange={handleImeiChange}
              maxLength="15"
            />
            <BtnSubmit
              className='check-field-button'
              text='לבדיקה'
              onclick={handleCheckImei}
            />
          </div>
          {imeiError && (
            <div className='input-error-check'>
              {imeiError}
            </div>
          )}
          {checkResult && (
            <div className='card-result'>
              {checkResult === 'success' && (
                <>
                  <Image src={successIcon} alt="success" className='result-icon' />
                  <span className='card-result-text'>מכשיר פתוח</span>
                </>
              )}
              {checkResult === 'failure' && (
                <>
                  <Image src={errorIcon} alt="error" className='result-icon' />
                  <span className='card-result-text'>מכשיר חסום</span>
                </>
              )}
            </div>
          )}
          <div className='card-link'>
            <span className='card-link-text' onClick={handleShowPopup}>איפה אפשר לראות את המספר הסידורי?</span>
          </div>
        </div>
      </div>
      {thirdImage && (
        <Image {...thirdImage} className='LostOrStolenBlock__third-image' />
      )}

      {showPopup && secondImage && (
        <div className='popup-overlay' onClick={handleClosePopup}>
          <div className='popup-content' onClick={(e) => e.stopPropagation()}>
            <button className='popup-close' onClick={handleClosePopup}>×</button>
            <Image {...secondImage} className='popup-image' />
          </div>
        </div>
      )}
    </div>
  );
};

export default LostOrStolen;
